import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { State } from '@app/store/state/state';

import { homeItemDetailRootSelector } from '@home-item-detail/store/selectors/home-item-detail.selector';
import {
  fetchHomeFlightOffersAction,
  fetchHomeItemDetailAction,
  clearFlightOfferAction,
  clearHomeItemDetail,
} from '@home-item-detail/store/actions/home-item-detail.actions';
import { clearFlightResultsAction, disabledFlightScrollAction } from '@flight-results/store/actions/flights-results.actions';
import { HomeItemDetail } from '@home-item-detail/entities/home-item-detail';
import { getHomeItemDetailState } from '@home-item-detail/store/selectors/ui.selector';
import { HomeFlightOffers } from '@shared/home-sections/entities/home-data.response';
import { TravelCmsHomeItemDetailPayload } from '@home/entities/travel-cms';
import { FlightType } from '@search-bar/entities/flight-type';

@Injectable()
export class HomeItemDetailFacade {

  constructor(
    protected store: Store<State>) {}

  public flightOffers$: Observable<HomeFlightOffers[]> = this.store.pipe(
    select(homeItemDetailRootSelector),
    map(state => state.flightOffers)
  );

  public homeItemDetail$: Observable<HomeItemDetail> = this.store.pipe(
    select(homeItemDetailRootSelector),
    map(state => state?.homeItemDetail));

  public isLoadingHomeItemDetail$: Observable<boolean> = this.store.pipe(
    select(getHomeItemDetailState),
    map(state => state.isLoadingHomeItemDetail)
  );

  public fetchHomeItemDetail(payload: TravelCmsHomeItemDetailPayload): void {
    this.store.dispatch(fetchHomeItemDetailAction({ payload }));
  }

  public fetchHomeFlightOffers(departure: string, arrival: string, flightType: FlightType): void {
    const isOneWay: number = flightType === FlightType.ONEWAY ? 1 : 0;
    this.store.dispatch(fetchHomeFlightOffersAction({ departure, arrival, isOneWay }));
  }

  public clearFlightResults(): void {
    this.store.dispatch(clearFlightResultsAction({ isMobile: false }));
  }

  public resetFlightOffer(): void {
    this.store.dispatch(clearFlightOfferAction());
  }

  public resetHomeItem(): void {
    this.store.dispatch(clearHomeItemDetail());
  }

  public disabledFlightScroll(payload: boolean = true): void {
    this.store.dispatch(disabledFlightScrollAction({ payload }));
  }
}
